<div class="toast-card toast-card--{{ item().type }}" role="alert" aria-live="assertive">
  <div class="toast-layout">
    <div class="toast-icon">
      @if (item().type === 'success') {
        <app-icon name="check-circle" [size]="18" />
      } @else if (item().type === 'error') {
        <app-icon name="alert-circle" [size]="18" />
      } @else if (item().type === 'warning') {
        <app-icon name="alert-circle" [size]="18" />
      } @else {
        <app-icon name="info" [size]="18" />
      }
    </div>
    <div class="toast-body">
      <div class="toast-title">{{ item().title }}</div>
      @if (item().message) {
        <div class="toast-message">{{ item().message }}</div>
      }
    </div>
    <button mat-icon-button class="toast-close" (click)="closed.emit()" aria-label="Close notification">
      <app-icon name="close" [size]="16" />
    </button>
  </div>
  <div class="toast-progress" [style.animation-duration]="item().duration + 'ms'"></div>
</div>
